import { render } from "./Datatables.vue?vue&type=template&id=d2cb22f6&scoped=true"
import script from "./Datatables.vue?vue&type=script&lang=js"
export * from "./Datatables.vue?vue&type=script&lang=js"

import "./Datatables.vue?vue&type=style&index=0&id=d2cb22f6&scoped=true&lang=css"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2cb22f6"]])

export default __exports__